import React, { useEffect, useRef, useState } from 'react'
import { Modal } from "react-bootstrap";
import ModalHeader from '../../../../Setup/Shared/ModalHeader';
import TextEditor from '../../../../../shared-components/TextEditor';
import FormValidator from '../../../../../utils/FormValidator';
import { enumUtil } from '../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../utils/ServerDataRequest';
import { isNull } from 'lodash';
import Loader from '../../../../shared/Loader/Loader';
import { Provider, useSelector } from 'react-redux';
import SuperSearchList from '../../../../shared/SuperSearch/SuperSearchList';
import DropdownValueHandler from '../../../../shared/SuperSearch/DropdownValueHandler';

export const AddNewMessage = (props) => {

    const { isOpenPopup, onClose, onCloseSave, ID } = props;

    const API_URL_GENERAL = enumUtil.controller.General
    const API_URL_Patient = enumUtil.controller.Patient
    const API_URL_PatientMessage = enumUtil.controller.PatientMessage

    let DropdownData = useSelector(state => state.GeneralDropDownsReducer);
    let ProviderDropDown = DropdownData?.Provider

    let Message_Modal = {
        "PatientID": "",
        "Subject": "",
        "Message": "",
        "FilePath": "",
        "FileName": "",
        "ProviderID": "",
    }


    let Description_Modal = {
        Message: '',
    }

    let Patient_Modal = {
        AccountNumber: "",
        Age: "",
        Gender: "",
        DOB: "",
        InsuranceID: "",
        InsuranceName: "",
        LocationID: '',
        LocationName: "",
        PatientID: '',
        PatientName: "",
        ProfilePicture: "",

    }

    let validation_modal = {
        Subject: "",
        Message: "",
        Provider: "",
    }
    let valModal = {}

    const fileInputRef = useRef()
    const [mainMessageModal, setMainMessageModal] = useState(Message_Modal);
    const [saveMessageModal, setSaveMessageModal] = useState({});
    const [messageDescriptionModal, setMessageDescriptionModal] = useState(Description_Modal);
    const [messageValidationModal, setMessageValidationModal] = useState(validation_modal);
    const [patientDetailsModal, setPatientDetailsModal] = useState(Patient_Modal);
    const [isPatientExist, setIsPatientExist] = useState(false);
    const [fileInput, setFileInput] = useState('');
    const [FileName, setFileName] = useState('');
    const [fileType, setFileType] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const [is, setIs] = useState(true)
    const formValidation = () => {
        let validationModal = {
            Subject: FormValidator(mainMessageModal?.Subject, enumUtil.enumValidationType.Required, "Subject"),
            Message: FormValidator(messageDescriptionModal?.Message, enumUtil.enumValidationType.Required, "Message"),
            Provider: FormValidator(mainMessageModal?.ProviderID, enumUtil.enumValidationType.Required, "Provider"),
        }
        setMessageValidationModal(validationModal);
        valModal = validationModal;
    }

    const handleOnChange = (e) => {
        setIs(false)
        const { name, value } = e.target;
        let modal = { ...mainMessageModal };
        let saveModal = { ...saveMessageModal };

        modal[name] = value;

        for (let property in Message_Modal) {
            if (property === name) {
                saveModal[name] = value;
            }
        }

        setMainMessageModal(modal);
        setSaveMessageModal(saveModal);
    }

    const handleOnChangeDescription = (e) => {
        const { name, value } = e.target;
        let modal = { messageDescriptionModal };

        const isEditorEmpty =
            value === '' ||
            value === '<p><br></p>' ||
            value === '<p></p>' ||
            value === '<br>' ||
            !value.replace(/<[^>]*>/g, '').trim();

        modal[name] = isEditorEmpty ? '' : value;

        // for (let property in Description_Modal) {
        //     if (property === name) {
        //         saveModal[name] = value;
        //     }
        // }

        setMessageDescriptionModal(modal);
    }

    const handleSelectedData = (selectedData, name, type) => {
        setIs(true)
        let modal = { ...mainMessageModal };
        let saveModal = { ...saveMessageModal };
        if (!isNull(selectedData)) {
            modal[name] = selectedData?.display;
            saveModal[name] = selectedData?.value + "";
        }
        else {
            modal[name] = "";
            saveModal[name] = "";
        }
        setMainMessageModal(modal);
        setSaveMessageModal(saveModal);
        return selectedData;
    };

    const handleFileChange = (e) => {

        const modal = { ...mainMessageModal };
        const saveModal = { ...saveMessageModal };

        const { files } = e.target;
        const file = files[0];

        setFileName(file.name)
        modal['FileName'] = file.name;
        saveModal['FileName'] = file.name;
        const fileType = file.type
        setFileType(fileType)
        if (fileType === 'image/png' || fileType === 'image/jpeg' || fileType === 'image/jpg') {
            const reader = new FileReader();
            reader.onloadend = (event) => {
                saveModal['FilePath'] = event.target.result.split("base64,")[1];
                setFileInput(event.target.result.split("base64,")[1]);
            };
            reader.readAsDataURL(file);
        } else {
            const reader = new FileReader();
            reader.onloadend = (event) => {
                saveModal['FilePath'] = event.target.result.split("base64,")[1];
                setFileInput(event.target.result.split("base64,")[1])
            };
            reader.readAsDataURL(file);
        }

        setMainMessageModal(modal);
        setSaveMessageModal(saveModal);

    };

    const removeFile = () => {

        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        setFileInput(null);
        setFileName(null);
        setFileType(null);

    }

    const LoadData = (ID) => {

        setPatientDetailsModal(Patient_Modal)
        setIsPatientExist(false);
        let saveModal = {
            "TABLENAME": enumUtil.enumAPITableName.CollectCopay,
            "SEARCHCRITERIA": {
                "PatientID": ID + "",
            }
        }

        setIsLoading(true);
        ServerRequestProtected(API_URL_Patient + '/FindPatientPay', 'post', saveModal)
            .then((reponse) => {

                setMainMessageModal({ ...mainMessageModal, ProviderID: reponse.Providers })
                setSaveMessageModal({ ...saveMessageModal, ProviderID: reponse.ProviderID + "" })

                setPatientDetailsModal(reponse);
                setIsPatientExist(true);
                setIsLoading(false);

            }).catch((error) => {

                setIsLoading(false);
                setIsPatientExist(false);
                setPatientDetailsModal(Patient_Modal)

            })
    }

    const handleSaveMessage = () => {

        formValidation();
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck);
        if (validation) {
            return
        }

        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert midnight (0) to 12
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        let time = `${formattedHours}:${formattedMinutes} ${ampm}`

        let saveModal = {
            "ID": "0",
            "TableName": enumUtil.enumAPITableName.PatientMessage,
            "Data": {
                "PatientID": patientDetailsModal?.PatientID + '',
                'Message': messageDescriptionModal?.Message,
                ...saveMessageModal
            }
        }

        setIsLoading(true);
        ServerRequestProtected(API_URL_PatientMessage + '/SavePatientMessage', 'post', saveModal)
            .then((response) => {
                console.log("response", response);
                onCloseSave();
                setIsLoading(false);
                setFileInput(null);
                setFileName(null);
                setFileType(null)
            }).catch((error) => {
                console.log('error', error)
                setIsLoading(false);
            })
    }

    useEffect(() => {

        if (!isNull(ID)) {
            LoadData(ID)
        }

    }, [ID])

    const MessageHeader = () => {
        return <p className='heading'>New Message</p>
    }
    return (
        <Modal show={isOpenPopup} onHide={isOpenPopup} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 add_new_messages_popup">
            <Modal.Body>
                {isLoading ? <Loader /> : null}
                <ModalHeader HeaderName={MessageHeader} DeletePopup={""} isClosed={onClose} key={631} Name={'AddNewPractrice'} />
                {isPatientExist ?
                    <div className="">
                        <div className="add_block_appointment w-100 mb-2">
                            <div class="ar-copay-img d-flex px-2 py-1-5">
                                <div class="img-container s-40 circle border-2 border-white me-2">
                                    <img src={patientDetailsModal?.ProfilePicture ? patientDetailsModal?.ProfilePicture : "https://www.w3schools.com/howto/img_avatar.png"} alt="" />
                                    <i class="icon-camera-outline"></i>
                                    <input type="file" name="Picture" id="Picture" />
                                </div>

                                <div class="ms-1 w-100">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p class="heading">{patientDetailsModal?.PatientName ?? ""}<span class="font-r ps-2px">{`${patientDetailsModal?.DOB ?? ""} ${patientDetailsModal?.Age ? `(${patientDetailsModal?.Age})` : ''} ${patientDetailsModal?.Gender ?? ""}`}</span></p>
                                        <p className="heading fs-11">Account # {patientDetailsModal?.AccountNumber}</p>
                                    </div>
                                    <p class="heading ar-dark-color">{patientDetailsModal?.InsuranceName ?? ""}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="add_block_appointment w-100 mb-2">
                        <div className='d-flex justify-content-between ar-copay-img mt-2'>
                            <div className="d-flex gap-4 py-2">
                                <div className="img-container s-40 circle border-2 ar-bgc-img">
                                </div>
                                <div>
                                    <p className="ar-bgc-content m-0" style={{ width: '100px' }}></p>
                                    <p className="ar-bgc-content w-30 m-0 mt-2" style={{ width: '200px' }}></p>
                                </div>
                            </div>
                            <div className='py-2 me-2 '>
                                <p className="ar-bgc-content w-30 m-0" style={{ width: '100px' }}></p>
                            </div>
                        </div>
                    </div>
                }

                <div className={`input mb-0 pb-2 ${messageValidationModal?.Subject ? 'error' : ''}`}>
                    <label className="pb-3px">Subject<span className='req'>*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        name="Subject"
                        id="Subject"
                        value={mainMessageModal?.Subject}
                        onChange={handleOnChange}
                    />
                    {messageValidationModal?.Subject}
                </div>
                <div className={`input mb-0 pb-2 ${messageValidationModal?.Provider ? 'error' : ''}`}>
                    <label className="pb-3px">Provider<span className='req'>*</span></label>
                    <SuperSearchList
                        type="client"
                        id="ProviderID"
                        name="ProviderID"
                        searchValue={mainMessageModal?.ProviderID}
                        data={ProviderDropDown}
                        is={is}
                        onChange={handleOnChange}
                        getSelectedData={handleSelectedData}
                        sup_btn="sup_btn-Inp"
                        sup_inp="superSearchVisitInp"
                        // disabled={true}
                        inputError={messageValidationModal?.Provider}
                    />
                    {messageValidationModal?.Provider}
                </div>
                <div class="ar_encounter_main_screen mb-12">
                    <div class="encounter_detail">
                        <div class={`ar-encounter-detail-content input ${messageValidationModal?.Message ? 'error' : ''}`}>
                            <label className='text ar-light-color pb-3px'>Message<span className='req'>*</span></label>
                            <TextEditor value={messageDescriptionModal.Message} setValue={value => handleOnChangeDescription({ target: { name: "Message", value } })} inputError={messageValidationModal?.Message ? true : false} />
                            {messageValidationModal?.Message}
                        </div>
                    </div>
                </div>
                <div className=''>
                    {/* <input
                        type="file"
                        id='Notes'
                        name="Notes"
                        className=' opacity-0 w-100 d-none'
                        value={mainMessageModal?.Notes}
                        onChange={handleOnChange}
                    /> */}
                    {FileName ? (
                        <div className="d-flex align-items-center gap-2">
                            <p className="heading lh-14">{FileName}</p>
                            <i className="icon-delete text-danger fs-12" onClick={removeFile}></i>
                        </div>
                    ) : (
                        <div className={messageValidationModal.FileNameVal ? 'form-group input error' : "form-group input mb-0"}>
                            <div className='upload-box__filePicker__Btn'>
                                <input
                                    type="file"
                                    id="fileInput"
                                    name="fileInput"
                                    className="inputfile opacity-0 position-absolute"
                                    accept=".pdf, .xls, .xlsx, .jpg, .jpeg, .png"
                                    onChange={handleFileChange}
                                // ref={fileInputRef}
                                />
                                <label className="d-flex align-items-center gap-5  px-2 w-100 text-nowrap cursor-pointe form-control justify-content-center" htmlFor='fileInput'>
                                    <i className='icon-Icon-metro-attachment fs-12'></i>
                                    <p className='text fs-13 ar-light-color'>Upload a File</p>
                                </label>
                            </div>

                            {messageValidationModal.FileNameVal}
                        </div>)}
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light ar_footer justify-content-end">
                <div className="d-flex justify-content-center align-items-center gap-2">
                    <button className="btn btn-outline px-10 h-100 dark-clr" onClick={onClose}>Cancel</button>
                    <button className="btn btn-validate px-10 h-100" onClick={handleSaveMessage}>Send</button>
                </div>
            </div>
        </Modal>
    )
}
